import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
//import App from './App';
import Home from './components/Home/Home';
import AboutView from './components/About/About';
import SkillsView from './components/Skills/Skills';
import PortfolioView from './components/Portfolio/Portfolio';
import ResumeView from './components/Resume/Resume';
import ContactView from './components/Contact/Contact';
import AboutEgypt from './components/About/AboutSection2';
import AboutLaboratoria from "./components/About/AboutLaboratoria";
import { HashRouter, Switch, Route } from 'react-router-dom';
import { Provider } from 'redux-zero/react'
import store from './store/store';
import registerServiceWorker from './registerServiceWorker';

const Index = () => (
    <Provider store={store}>
        <HashRouter>
            <Switch>
                <Route exact path='/' component={Home} />
                <Route path='/home' component={Home} />
                <Route path='/aboutme' component={AboutView} />
                <Route path='/skills' component={SkillsView} />
                <Route path='/portfolio' component={PortfolioView} />
                <Route path='/resume' component={ResumeView} />
                <Route path='/contact' component={ContactView} />
                <Route path='/aboutegypt' component={AboutEgypt} />
                <Route path='/aboutlab' component={AboutLaboratoria}/>
            </Switch>
        </HashRouter>
    </Provider>
)

ReactDOM.render(<Index />, document.getElementById('root'));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js